module.exports = __webpack_public_path__ + "static/recruitment_drive_mtg_clb-4a54647967b3850579fd50492af9611f.webp";